import moment from 'moment'
import _cloneDeep from 'lodash/cloneDeep'

const { collectDay, judgeSomeMonthMore, checkIsWholeMonth, formatNumber, diffDate, monthAndRemainDays } = require('./utils')
const { dateConversion, addStairAmount, reCalculatePlanAmount } = require('./stair')

const btp = {
  threeMonth: 3,
  halfYear: 6,
  year: 12,
  month: false,
  monthN: false,
  thirty: false,
  week: false,
  day: false,
  once: false,
}

export function calculateTotal(tableData) {
  const list = []
  tableData.forEach((item) => {
    if (!item.complete) return
    if (Number(item.payMode) === 6) { // 一次性付款 总和等于金额
      list.push(
        {
          code: item.fundType,
          number: Number(item.planAmount),
        },
      )
      return
    }
    list.push(
      {
        code: item.fundType,
        number: item.items.reduce((acc, cur) => {
          return acc + Number(cur.planAmount)
        }, 0),
      },
    )
  })
  return list
}

// <------------------ 应收预览---------------------->
// 获取缴款日期方法(是否在款项周期范围内)
/**
 * getDudate参数说明
 * type：收款方式（1年付，2半年付，3周付，4月付（满月），5月付（自然月），8三个月一付，9 30天一付
 * newStartDate：新增期数的开始时间
 * newEndDate：新增期数的结束时间
 * payDay：缴款日
 */
// 主要是计算新增期数的应收日期
export function getDudate(type, newStartDate, newEndDate, payDay) {
  const tempStartDate = new Date(newStartDate)// 临时的款项周期开始时间
  const tempEndDate = new Date(newEndDate)// 临时的款项周期结束时间
  // currentStartDay：当前款项周期开始时间具体是几号；currentEndDay：当前项周期结束时间具体是几号；newPayDay：下一期数的缴款日（即应收日期）
  let newPayDay
  // type :3 收款方式：周付
  const currentStartDay = type === 3 ? tempStartDate.getDay() : tempStartDate.getDate()
  const currentEndDay = type === 3 ? tempEndDate.getDay() : tempEndDate.getDate()

  const csdMinusPd = currentStartDay - payDay// 当前款项周期开始时间与缴款日差几天（时间差）
  const cedMinusPd = currentEndDay - payDay// 当前款项周期结束时间与缴款日差几天（时间差）

  // 周付的话不在款项周期范围(需要考虑边界值)
  if (csdMinusPd > 0 && cedMinusPd < 0) {
    // 应收日期等于款项周期开始时间或是应收日期小于款项周期开始时间并且应收日期小于款项周期结束时间并且收款类型为自然月
    newPayDay = newStartDate
    // 周付的话在款项周期范围
  } else if (// 应收日期等于款项周期开始时间或是应收日期小于款项周期开始时间并且应收日期小于款项周期结束时间并且收款类型为自然月
    csdMinusPd === 0 ||
    (csdMinusPd > 0 && cedMinusPd > 0 && [5].includes(type))
  ) {
    newPayDay = newStartDate
  } else if (cedMinusPd === 0 && [3, 4, 5, 9].includes(type)) {
    // 应收日期等于款项周期结束时间并且收款类型为周付，月付（自然月、满月），30天一付
    newPayDay = newEndDate
  } else if (
    // （应收日期小于款项周期的开始和结束时间或是应收日期等于款项周期的结束时间）并且收款类型为年付、半年付、三个月一付，月付（满月）、周付、30天一付
    ((csdMinusPd > 0 && cedMinusPd > 0) || cedMinusPd === 0) &&
    [1, 2, 3, 4, 8, 9].includes(type)
  ) {
    if (type === 3) { // 周付
      // 7-currentStartDay+payDay计算付款日和款项开始时间的差值
      newPayDay = tempStartDate.setDate(
        new Date(
          tempStartDate.getDate() + (7 - currentStartDay + payDay),
        ),
      )
    } else {
      newPayDay = tempStartDate.setDate(
        new Date(
          tempStartDate.setMonth(tempStartDate.getMonth() + 1),
        ).getDate() - csdMinusPd,
      )
    }


    // 周付的话在款项周期范围
  } else if (// 应收日期小于款项周期的开始和结束时间或是（应收日期小于款项周期的结束时间并且大于开始时间）
    (csdMinusPd < 0 && cedMinusPd < 0) ||
    (csdMinusPd < 0 && cedMinusPd > 0)
  ) {
    newPayDay = tempStartDate.setDate(
      tempStartDate.getDate() + (payDay - currentStartDay),
    )
  }
  return newPayDay
}

// 获取当前月份的最后一天
export function getCurrentMonthLastDay(cuttentDate) {
  const date = new Date(cuttentDate)
  const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  return new Date(endDate).getTime()
}

// 计算新增条目的款项周期和应付日期
/**
 * payMode:收款方式（年付、半年付、三月一付...)
 * payDay: 缴款日
 * payPost： 是否后置缴款（1后置缴款，0非后置缴款）
 * tableDataFrom: 应收单预览表格项
 * setDate：设置当前月份的日期（几号）
 * getDate：获取当前月份的日期（几号）
 */
export function getNextDate(row) {
  // setDate计算方法优势：只关注当前是几号，不用关心 月份和年份
  const { payMode, payDay, payPost, tableDataFrom } = row
  const len = tableDataFrom.tableData.length - 1// 应收单预览数据最大索引（数组）
  const lastItem = tableDataFrom.tableData[len].accruedCycle// 应收单预最后一项的款项周期（数组）
  const endDate = new Date(lastItem[1])// 应收单预最后一项的款项周期的结束时间
  // 由于新增期数需要用最后一项的款项周期的结束时间做计算，
  // 所以克隆应收单预最后一项的款项周期的结束时间，
  // 防止由于计算污染该结束时间（比如当前期数款项周期结束时间为4/30，计算下一周期开始时间setDate后就会改成5月，下一周期的款项周期结束时间不能以5月累加，应该是以4月计算往后累加时间）
  const cloneEndDate = _cloneDeep(endDate)
  const newStartDate = cloneEndDate.setDate(endDate.getDate() + 1)// 计算新增期数的开始时间，返回时间戳
  // 需要计算新增期数的款项周期结束时间（newEndDate）和应收日期（newPayDay）

  let newEndDate; let
    newPayDay
  switch (payMode) {
  // 周付
    case 3:
    // newEndDate = cloneEndDate.setDate(endDate.getDate() + 7)
      newEndDate = endDate.setDate(endDate.getDate() + 7)
      newPayDay = getDudate(3, newStartDate, newEndDate, payDay)
      break
    // 月付（满月)
    case 4:
    // newEndDate = cloneEndDate.setMonth(endDate.getMonth() + 1)
      newEndDate = endDate.setMonth(endDate.getMonth() + 1)
      newPayDay = getDudate(4, newStartDate, newEndDate, payDay)
      break
    // 月付（自然月）
    case 5:
    // newEndDate = cloneEndDate.setTime(
      newEndDate = endDate.setTime(
        getCurrentMonthLastDay(newStartDate),
      )
      newPayDay = getDudate(5, newStartDate, newEndDate, payDay)
      break
    // 三个月一付
    case 8:
    // newEndDate = cloneEndDate.setMonth(endDate.getMonth() + 3)
      newEndDate = endDate.setMonth(endDate.getMonth() + 3)
      newPayDay = getDudate(8, newStartDate, newEndDate, payDay)
      break
    // 半年付
    case 2:
    // newEndDate = cloneEndDate.setMonth(endDate.getMonth() + 6)
      newEndDate = endDate.setMonth(endDate.getMonth() + 6)
      newPayDay = getDudate(2, newStartDate, newEndDate, payDay)
      break
    // 年付
    case 1:
    // newEndDate = cloneEndDate.setFullYear(endDate.getFullYear() + 1)
      newEndDate = endDate.setFullYear(endDate.getFullYear() + 1)
      newPayDay = getDudate(1, newStartDate, newEndDate, payDay)
      break
    // 30天一付
    case 9:
    // newEndDate = cloneEndDate.setDate(endDate.getDate() + 30)
      newEndDate = endDate.setDate(endDate.getDate() + 30)
      newPayDay = getDudate(9, newStartDate, newEndDate, payDay)
      break
    default:
  }
  // if (payPost == 1) {
  //   newPayDay = cloneEndDate.setDate(new Date(newEndDate).getDate() + 1)
  // }
  if (Number(payPost) === 1) {
    newPayDay = endDate.setDate(new Date(newEndDate).getDate() + 1)
  }

  return {
    // accruedCycle: [newStartDate, newEndDate],
    accruedCycle: [moment(newStartDate).format('YYYY-MM-DD HH:mm:ss'), moment(newEndDate).format('YYYY-MM-DD HH:mm:ss')],
    dueDate: moment(new Date(newPayDay)).format('YYYY-MM-DD'),
  }
}

// <-------------------- 以下部分是计算周期和周期详情 ---------------------->
// 周期计算
export function calculateCycle(params) {
  const { paymentMethods, rentPlanFeeType, endTime, startTime } = params
  let { giveDays } = params
  if (!rentPlanFeeType) {
    // 未传入付款方式！
    return false
  } else if (!endTime || !startTime) {
    // 无收款起止日，请确认开始时间和结束时间！
    return false
  }
  const paymentType = getAlias(paymentMethods, rentPlanFeeType)
  if (!paymentType) {
    // 未匹配到付款方式，请检查！
    return false
  }
  try {
    giveDays = Number(giveDays)
  } catch (err) {
    // 赠送天数格式错误
    return false
  }
  const startMomentTime = moment(startTime)
  const endMomentTime = moment(endTime)

  const startMomentTimeCP = _cloneDeep(startMomentTime) // 开始时间copy
  const stMonthLastDay = startMomentTimeCP.endOf('month').format('YYYY-MM-DD') // 开始时间的当月最后一天
  const stMonthFirstDay = startMomentTimeCP.startOf('month').format('YYYY-MM-DD') // 开始时间的当月第一天

  const stDiffDays = moment(stMonthLastDay).diff(startMomentTime, 'days') // 开始时间到当月底的天数差

  let totalCycle = 0 // 总期数
  let fCycle = 0
  let realEndMomentTime = ''
  let realEndTime = ''
  let gCycle = 0 // 赠送天数的总期数
  let extraDOrM = 0 // 剩余天数或月数
  if (giveDays && giveDays > 0) {
    realEndTime = endMomentTime.subtract(giveDays, 'days').format('YYYY-MM-DD')
    realEndMomentTime = moment(realEndTime)
    gCycle = 1 // 只要有赠送天数，就算一个周期
  } else {
    realEndMomentTime = endMomentTime
  }
  const realEndMomentTimeCP = _cloneDeep(realEndMomentTime) // 结束时间copy
  // 如果赠送天数正好是开始时间和结束时间的天数差，总周期为一
  const dd = moment(endTime).diff(moment(startTime), 'days') + 1
  if (Number(dd) === Number(giveDays)) {
    totalCycle = 1
    return {
      totalCycle,
      realEndTime: giveDays > 0 ? realEndTime : endTime, // 除赠送天数后的最后一个周期的结束日期
    }
  }
  // 满月
  if (paymentType === 'month') {
    fCycle = realEndMomentTime.diff(startMomentTime, 'months')
    const someOneDay = startMomentTime.add(fCycle, 'months').format('YYYY-MM-DD')
    extraDOrM = realEndMomentTime.diff(someOneDay, 'days') // 剩余天数
  // 自然月
  } else if (paymentType === 'monthN') {
    if (stMonthFirstDay === startMomentTime.format('YYYY-MM-DD')) { // 开始时间即自然月的第一天
      fCycle = realEndMomentTime.diff(startMomentTime, 'months')
      const someOneDay = startMomentTimeCP.add(fCycle, 'months').format('YYYY-MM-DD')
      extraDOrM = realEndMomentTime.diff(someOneDay, 'days') // 剩余天数
    } else if (stDiffDays > 0 || stDiffDays === 0) {
      // 开始时间非自然月第一天
      // 开始在当月中间或者正好是最后一天，周期加1
      fCycle += 1
      const fromSecCycle = realEndMomentTimeCP.diff(moment(stMonthLastDay).add(1, 'd').format('YYYY-MM-DD'), 'months')
      fCycle += fromSecCycle
      const someOneDay = moment(stMonthLastDay).add(fromSecCycle, 'months').format('YYYY-MM-DD')
      const someOneDayMonLastDay = moment(someOneDay).endOf('month').format('YYYY-MM-DD')
      extraDOrM = realEndMomentTime.diff(someOneDayMonLastDay, 'days') // 剩余天数
      if (moment(realEndMomentTime).format('YYYY-MM-DD') === someOneDayMonLastDay) {
        extraDOrM = -1
      } else if (moment(realEndMomentTime).isBefore(someOneDayMonLastDay)) {
        extraDOrM = -1
      }
    }
  // 30天一周期
  } else if (paymentType === 'thirty') {
    fCycle = Math.trunc(endMomentTime.diff(startMomentTime, 'days') / 30)
    const someOneDay = startMomentTimeCP.add(fCycle * 30, 'days').format('YYYY-MM-DD') // 开始时间加所有周期和后的某一天
    extraDOrM = realEndMomentTime.diff(someOneDay, 'days') // 剩余天数
  // 一周为一个周期
  } else if (paymentType === 'week') {
    fCycle = realEndMomentTime.diff(startMomentTime, 'weeks')
    const someOneDay = startMomentTimeCP.add(fCycle, 'weeks').format('YYYY-MM-DD') // 开始时间加所有周期和后的某一天
    extraDOrM = realEndMomentTime.diff(someOneDay, 'days') // 剩余天数
  // 三个月一周期
  } else if (paymentType === 'threeMonth') {
    const monsNum = realEndMomentTime.diff(startMomentTime, 'months') // 总月数
    fCycle = Math.trunc(monsNum / 3)
    extraDOrM = monsNum - fCycle * 3 // 剩余月数
  // 半年周期
  } else if (paymentType === 'halfYear') {
    const allMons = realEndMomentTime.diff(startMomentTime, 'months') // 总月数
    fCycle = Math.trunc(allMons / 6)
    extraDOrM = realEndMomentTime.diff(startMomentTimeCP.add(fCycle * 6, 'months'), 'months') // 剩余月数
  // 一年周期
  } else if (paymentType === 'year') {
    fCycle = realEndMomentTime.diff(startMomentTime, 'years') // 总年数
    extraDOrM = fCycle && realEndMomentTime.diff(startMomentTimeCP.add(fCycle, 'years'), 'months') // 剩余月数
  } else if (paymentType === 'once') {
    fCycle = 1
    extraDOrM = -1
  }
  // 如果有剩余天数或者是剩余月数，周期加1
  if (Number(extraDOrM) >= 0) {
    totalCycle = fCycle + 1
  } else {
    totalCycle = fCycle
  }
  // 如果有赠送天数，周期加一
  if (giveDays > 0) {
    totalCycle += gCycle
  }
  return {
    totalCycle,
    realEndTime: giveDays > 0 ? realEndTime : endTime, // 除赠送天数后的最后一个周期的结束日期
  }
}

// 匹配付款方式
export function getAlias(paymentMethods, rentPlanFeeType) {
  if (paymentMethods.length === 0) {
    // 支付枚举数据为空，请核对！
    return false
  }
  const codeMap = {
    1: 'year',
    2: 'halfYear',
    3: 'week',
    4: 'month',
    5: 'monthN',
    6: 'once',
    7: '', // 司机匹配模式的保留参数（若传入7，无对应支付方式）
    8: 'threeMonth',
    9: 'thirty',
  }
  let noo = [...paymentMethods]
  if (!paymentMethods[0].alias) {
    paymentMethods.forEach((item) => {
      item.alias = codeMap[item.code]
    })
    noo = [...paymentMethods]
  }
  return noo.find((j) => j.code === rentPlanFeeType).alias
}

// 周期详情
export function cycleDetail(paramsAll) {
  const { totalCycle, realEndTime } = calculateCycle(paramsAll)
  let cycleArr = []
  const {
    paymentMethods,
    rentPlanFeeType,
    payDay,
    delayPayFlag,
    endTime,
    startTime,
    dailyRule, // 此参数代表日租金规则，0：按照开始月自然天数 1：按照30天
    wholeMonth = false, // 若付款方式为自然月，是否按照[首尾月相加是足月]的情况计算首尾月的付款金额
    feeConfig, // 阶梯付款配置
  } = paramsAll
  let { giveDays, arrears } = paramsAll
  if (!rentPlanFeeType) {
    // 未传入付款方式
    return false
  } else if (!endTime || !startTime) {
    // 无收款起止日，请确认开始时间和结束时间
    return false
  }
  const paymentType = getAlias(paymentMethods, rentPlanFeeType)
  if (!paymentType) {
    // 未匹配到付款方式
    return false
  }
  try {
    giveDays = Number(giveDays)
  } catch (err) {
    // 赠送天数格式错误
    return false
  }

  // 阶梯配置校验
  if (!feeConfig) {
    // 未传入阶梯付款配置项
    return false
  }

  // 计算阶梯配置的具体时间
  // 是否开启阶梯付款方式 true 1-开启，0-未开启
  const { isOpen, feePiecewiseConfigList } = feeConfig.feePiecewiseCalculation

  // 配置的阶梯时间和收/付款起止日的时间做比较，若阶梯时间范围小于收/付款结束日，提示报错
  if (isOpen && diffDate(feeConfig, startTime, endTime)) {
    // 阶梯时间范围小于收/付款结束日，请重新配置阶梯的范围
    return false
  }

  // 阶梯配置中的value值string转Number
  isOpen && feePiecewiseConfigList.forEach((item) => {
    Object.keys(item).forEach((key) => {
      item[key] = Number(item[key])
    })
  })

  const cloneFeePiecewiseConfigList = _cloneDeep(feePiecewiseConfigList)

  // 阶梯时间
  const ladderDate = !!isOpen && dateConversion(startTime, cloneFeePiecewiseConfigList) // 阶梯时间

  // 若配置了阶梯，arrears 的值为空，重新赋值，保证代码执行不阻塞，保证若付款方式为自然月的情况下，第一个月应付金额能正常计算
  arrears = (!!isOpen && feePiecewiseConfigList[0].amount) || arrears

  const startMomentTime = moment(startTime)
  const startMomentTimeCP = _cloneDeep(startMomentTime) // 开始时间copy
  const stMonthLastDay = startMomentTimeCP.endOf('month').format('YYYY-MM-DD') // 开始时间的当月最后一天

  if (paymentType === 'month') {
    const firAdOn = startMomentTime.add(1, 'months').format('YYYY-MM-DD')
    const firstEndTime = moment(firAdOn).subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
    const firstStartTime = moment(startTime).format('YYYY-MM-DD 00:00:00')
    const firstCycle = {
      startCycleDate: firstStartTime,
      endCycleDate: firstEndTime,
      planAmount: arrears,
      num: 1,
    }
    const params = {
      type: 'month',
      st: firstStartTime,
      ent: firstEndTime,
      payDay,
      delayPayFlag,
    }
    const dueDate = dueDateFun(params)
    firstCycle.dueDate = dueDate
    cycleArr.push(firstCycle)
    const objPar = {
      paymentType,
      totalCycle,
      firstStartTime,
      firstEndTime,
      arrears,
      payDay,
      delayPayFlag,
    }
    const cds = whileCalCycleFun(objPar) || []
    cycleArr = cycleArr.concat(cds)
  } else if (paymentType === 'monthN') {
    // 判断首尾月相加是否为整月
    checkIsWholeMonth(paymentMethods, startTime, endTime)
    const firstStartTime = moment(startTime).format('YYYY-MM-DD 00:00:00')
    const firstEndTime = moment(stMonthLastDay).format('YYYY-MM-DD 00:00:00')
    const firstCycle = {
      startCycleDate: firstStartTime,
      endCycleDate: firstEndTime,
      planAmount: arrears,
      num: 1,
    }
    const params = {
      type: 'monthN',
      st: firstStartTime,
      ent: firstEndTime,
      payDay,
      delayPayFlag,
    }
    const dueDate = dueDateFun(params)
    firstCycle.dueDate = dueDate
    // 单独计算自然月第一个周期的应缴费用 开始----
    const arDa = moment(firstEndTime).diff(moment(firstStartTime), 'days') + 1
    const st = moment(firstCycle.startCycleDate).format('YYYY-MM-DD')
    const laMonAlDa = collectDay(st, paymentType, dailyRule) // 计算固定周期的实际总天数
    const com = Math.ceil((arrears / laMonAlDa * arDa).toFixed(2))
    const planAmount = Number(((Number(com) > Number(arrears)) || (Number(com) === Number(arrears))) ? arrears : com)
    firstCycle.planAmount = planAmount
    // 单独计算自然月第一个周期的应缴费用 结束----
    cycleArr.push(firstCycle)
    const objPar = {
      paymentType,
      totalCycle,
      firstStartTime,
      firstEndTime,
      arrears,
      payDay,
      delayPayFlag,
    }
    const cds = whileCalCycleFun(objPar) || []
    cycleArr = cycleArr.concat(cds)
  } else if (paymentType === 'thirty') {
    const firAdOn = startMomentTime.add(30, 'days').format('YYYY-MM-DD')
    const firstEndTime = moment(firAdOn).subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
    const firstStartTime = moment(startTime).format('YYYY-MM-DD 00:00:00')
    const firstCycle = {
      startCycleDate: firstStartTime,
      endCycleDate: firstEndTime,
      planAmount: arrears,
      num: 1,
    }
    const params = {
      type: 'thirty',
      st: firstStartTime,
      ent: firstEndTime,
      payDay,
      delayPayFlag,
    }
    const dueDate = dueDateFun(params)
    firstCycle.dueDate = dueDate
    cycleArr.push(firstCycle)
    const objPar = {
      paymentType,
      totalCycle,
      firstStartTime,
      firstEndTime,
      arrears,
      payDay,
      delayPayFlag,
    }
    const cds = whileCalCycleFun(objPar) || []
    cycleArr = cycleArr.concat(cds)
  } else if (paymentType === 'week') {
    const days = moment(endTime).diff(moment(startTime), 'days') + 1
    const firAdOn = startMomentTime.add(7, 'days').format('YYYY-MM-DD')
    let firstEndTime = moment(firAdOn).subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
    if (days < 7) { // 第一个周期小于一周，结束时间以合同结束时间为准
      firstEndTime = moment(endTime).format('YYYY-MM-DD 00:00:00')
    }
    const firstStartTime = moment(startTime).format('YYYY-MM-DD 00:00:00')
    const firstCycle = {
      startCycleDate: firstStartTime,
      endCycleDate: firstEndTime,
      planAmount: arrears,
      num: 1,
    }
    const params = {
      type: 'week',
      st: firstStartTime,
      ent: firstEndTime,
      payDay,
      delayPayFlag,
    }
    const dueDate = dueDateFun(params)
    firstCycle.dueDate = dueDate
    cycleArr.push(firstCycle)
    const objPar = {
      paymentType,
      totalCycle,
      firstStartTime,
      firstEndTime,
      arrears,
      payDay,
      delayPayFlag,
    }
    const cds = whileCalCycleFun(objPar) || []
    cycleArr = cycleArr.concat(cds)
  } else if (paymentType === 'threeMonth') {
    const firAdOn = startMomentTime.add(3, 'months').format('YYYY-MM-DD')
    const firstEndTime = moment(firAdOn).subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
    const firstStartTime = moment(startTime).format('YYYY-MM-DD 00:00:00')
    const firstCycle = {
      startCycleDate: firstStartTime,
      endCycleDate: firstEndTime,
      planAmount: arrears,
      num: 1,
    }
    const params = {
      type: 'threeMonth',
      st: firstStartTime,
      ent: firstEndTime,
      payDay,
      delayPayFlag,
    }
    const dueDate = dueDateFun(params)
    firstCycle.dueDate = dueDate
    cycleArr.push(firstCycle)
    const objPar = {
      paymentType,
      totalCycle,
      firstStartTime,
      firstEndTime,
      arrears,
      payDay,
      delayPayFlag,
    }
    const cds = whileCalCycleFun(objPar) || []
    cycleArr = cycleArr.concat(cds)
  } else if (paymentType === 'halfYear') {
    const firAdOn = startMomentTime.add(6, 'months').format('YYYY-MM-DD')
    const firstEndTime = moment(firAdOn).subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
    const firstStartTime = moment(startTime).format('YYYY-MM-DD 00:00:00')
    const firstCycle = {
      startCycleDate: firstStartTime,
      endCycleDate: firstEndTime,
      planAmount: arrears,
      num: 1,
    }
    const params = {
      type: 'halfYear',
      st: firstStartTime,
      ent: firstEndTime,
      payDay,
      delayPayFlag,
    }
    const dueDate = dueDateFun(params)
    firstCycle.dueDate = dueDate
    cycleArr.push(firstCycle)
    const objPar = {
      paymentType,
      totalCycle,
      firstStartTime,
      firstEndTime,
      arrears,
      payDay,
      delayPayFlag,
    }
    const cds = whileCalCycleFun(objPar) || []
    cycleArr = cycleArr.concat(cds)
  } else if (paymentType === 'year') {
    const firAdOn = startMomentTime.add(1, 'years').format('YYYY-MM-DD')
    const firstEndTime = moment(firAdOn).subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
    const firstStartTime = moment(startTime).format('YYYY-MM-DD 00:00:00')
    const firstCycle = {
      startCycleDate: firstStartTime,
      endCycleDate: firstEndTime,
      planAmount: arrears,
      num: 1,
    }
    const params = {
      type: 'year',
      st: firstStartTime,
      ent: firstEndTime,
      payDay,
      delayPayFlag,
    }
    const dueDate = dueDateFun(params)
    firstCycle.dueDate = dueDate
    cycleArr.push(firstCycle)
    const objPar = {
      paymentType,
      totalCycle,
      firstStartTime,
      firstEndTime,
      arrears,
      payDay,
      delayPayFlag,
    }
    const cds = whileCalCycleFun(objPar) || []
    cycleArr = cycleArr.concat(cds)
  }
  // 最后一个周期和倒数第二个周期的应缴费用调整
  let st = ''
  let en = ''
  let areasDays = '' // 最后一个周期或倒数第二个周期的总天数
  let com = ''
  let laMonAlDa = ''
  let planAmount = ''
  if (cycleArr.length > 1) {
    if (!giveDays) { // 无赠送天数
      cycleArr[cycleArr.length - 1].endCycleDate = moment(endTime).format('YYYY-MM-DD 00:00:00')
      st = cycleArr[cycleArr.length - 1].startCycleDate
      en = cycleArr[cycleArr.length - 1].endCycleDate
    } else { // 有赠送天数
      const penuCycleEndTime = moment(realEndTime).format('YYYY-MM-DD') // 倒数第二个周期的最后一天
      cycleArr[cycleArr.length - 2].endCycleDate = moment(penuCycleEndTime).format('YYYY-MM-DD 00:00:00')
      cycleArr[cycleArr.length - 1].endCycleDate = moment(endTime).format('YYYY-MM-DD 00:00:00')
      cycleArr[cycleArr.length - 1].startCycleDate = moment(penuCycleEndTime).add(1, 'days').format('YYYY-MM-DD 00:00:00')
      st = cycleArr[cycleArr.length - 2].startCycleDate
      en = cycleArr[cycleArr.length - 2].endCycleDate
    }
    // 费用和应缴日期调整

    // 年付、半年付、三个月付 的计算方式需要先算满月，再算剩余天
    if (btp[paymentType]) {
      const mountObj = monthAndRemainDays(st, en)
      const mount_months = arrears / btp[paymentType] * mountObj.totalMonth
      const mount_days = arrears / btp[paymentType] / mountObj.lastPeriodTotalDays * mountObj.remainDays
      planAmount = Math.ceil((mount_months + mount_days).toFixed(2))
    } else {
      areasDays = moment(en).diff(moment(st), 'days') + 1
      laMonAlDa = collectDay(st, paymentType, dailyRule) // 计算固定周期的实际总天数
      com = Math.ceil((arrears / laMonAlDa * areasDays).toFixed(2))
      planAmount = Number(((Number(com) > Number(arrears)) || (Number(com) === Number(arrears))) ? arrears : com)
    }
    if (!giveDays) { // 无赠送天数
      cycleArr[cycleArr.length - 1].planAmount = planAmount
    } else { // 有赠送天数
      cycleArr[cycleArr.length - 2].planAmount = planAmount
      cycleArr[cycleArr.length - 1].planAmount = 0
    }
  } else { // 只有一个周期
    cycleArr[cycleArr.length - 1].startCycleDate = startTime
    cycleArr[cycleArr.length - 1].endCycleDate = endTime

    // 费用调整

    // 年付、半年付、三个月付 的计算方式需要先算满月，再算剩余天
    if (btp[paymentType]) {
      const mountObj = monthAndRemainDays(startTime, endTime)
      const mount_months = arrears / btp[paymentType] * mountObj.totalMonth
      const mount_days = arrears / btp[paymentType] / mountObj.lastPeriodTotalDays * mountObj.remainDays
      planAmount = Math.ceil((mount_months + mount_days).toFixed(2))
      cycleArr[cycleArr.length - 1].planAmount = planAmount
    } else {
      st = moment(cycleArr[cycleArr.length - 1].startCycleDate).format('YYYY-MM-DD')
      en = moment(cycleArr[cycleArr.length - 1].endCycleDate).format('YYYY-MM-DD')
      areasDays = moment(en).diff(moment(st), 'days') + 1
      laMonAlDa = collectDay(st, paymentType, dailyRule) // 计算固定周期的实际总天数
      com = Math.ceil((arrears / laMonAlDa * areasDays).toFixed(2))
      planAmount = Number(((Number(com) > Number(arrears)) || (Number(com) === Number(arrears))) ? arrears : com)
      cycleArr[cycleArr.length - 1].planAmount = planAmount
    }
  }
  // 最后一个缴费周期的应缴日期调整
  const params = {
    type: paymentType,
    st: cycleArr[cycleArr.length - 1].startCycleDate,
    ent: cycleArr[cycleArr.length - 1].endCycleDate,
    payDay,
    delayPayFlag,
  }
  const dueDate = dueDateFun(params)
  cycleArr[cycleArr.length - 1].dueDate = dueDate
  // 若缴费周期大于1，重新调整倒数第二个周期的应缴日期和应缴费用
  if (cycleArr.length > 1) {
    const newParams = {
      type: paymentType,
      st: cycleArr[cycleArr.length - 2].startCycleDate,
      ent: cycleArr[cycleArr.length - 2].endCycleDate,
      payDay,
      delayPayFlag,
    }
    const newDueDate = dueDateFun(newParams)
    cycleArr[cycleArr.length - 2].dueDate = newDueDate
  }
  // 如果赠送天数正好是开始时间和结束时间的天数差，周期为一个
  const dd = moment(endTime).diff(startTime, 'days') + 1
  if (Number(dd) === Number(giveDays)) {
    cycleArr[0].planAmount = 0
  }
  // 若付款方式为自然月，且要求按照首尾相加是足月的情况计算首尾月的付款金额
  if (paymentType === 'monthN' && wholeMonth) {
    // 先判断首尾月是否为整月
    const isWholeMonth = checkIsWholeMonth(startTime, endTime)
    if (isWholeMonth && cycleArr.length > 1) { // 是整月且周期数大于1
      const fee = (arrears - cycleArr[0].planAmount).toFixed(2)
      // cycleArr[cycleArr.length - 1].planAmount = (+fee % 1) === 0 ? fee : Math.ceil(fee)
      cycleArr[cycleArr.length - 1].planAmount = fee
    } else if (!isWholeMonth && cycleArr.length > 1) { // 非整月且周期数大于1
      const flag = judgeSomeMonthMore(startTime, endTime).lessDaysMonth
      const days = judgeSomeMonthMore(startTime, endTime).lessDays
      if (flag === 'st') { // 开始月份天数最少，重新计算尾月的大单位月租金
        const newSt = moment(cycleArr[cycleArr.length - 1].startCycleDate).format('YYYY-MM-DD')
        const newEn = moment(cycleArr[cycleArr.length - 1].endCycleDate).format('YYYY-MM-DD')
        const newAreasDays = moment(newEn).diff(moment(newSt), 'days') + 1
        const newCom = Math.ceil((arrears / days * newAreasDays).toFixed(2))
        const newPlanAmount = Number(((Number(newCom) > Number(arrears)) || (Number(newCom) === Number(arrears))) ? arrears : newCom)
        cycleArr[cycleArr.length - 1].morePlanAmount = newPlanAmount
      } else if (flag === 'et') { // 结束月份天数最少，重新计算首月的大单位月租金
        const firstStartTime = moment(startTime).format('YYYY-MM-DD 00:00:00')
        const firstEndTime = moment(stMonthLastDay).format('YYYY-MM-DD 00:00:00')
        const arDa = moment(firstEndTime).diff(moment(firstStartTime), 'days') + 1
        const newCom = Math.ceil((arrears / days * arDa).toFixed(2))
        const newPlanAmount = Number(((Number(newCom) > Number(arrears)) || (Number(newCom) === Number(arrears))) ? arrears : newCom)
        cycleArr[0].morePlanAmount = newPlanAmount
      }
    }
  }
  formatNumber(cycleArr)
  if (isOpen) {
    const addStairAmountArr = addStairAmount(isOpen, ladderDate, cycleArr)
    reCalculatePlanAmount(paymentType, addStairAmountArr, dailyRule)
    return addStairAmountArr
  }
  return cycleArr
}

// 根据周期数循环出周期详情
function whileCalCycleFun(objPar = {}) {
  const { paymentType, totalCycle, firstStartTime, firstEndTime, arrears, payDay, delayPayFlag } = objPar
  let flag = false
  if (!paymentType) {
    // 未传入付款方式！
    flag = true
  } else if (!totalCycle) {
    // 未传入总周期！
    flag = true
  } else if (!firstStartTime) {
    // 未传入第一个周期的开始时间！
    flag = true
  } else if (!firstEndTime) {
    // 未传入第一个周期的结束时间！
    flag = true
  } else if (!arrears) {
    // 未传入每期收取！
    flag = true
  } else if (!payDay && !delayPayFlag) {
    // 缴款日-payDay和后置缴款-delayPayFlag必保证有一个有值！
    flag = true
  }
  if (flag) return []
  let i = 0
  let multiple = 1 // 倍数
  let dateType = ''
  const nArr = []
  let currentStartTime = ''
  let currentEndTime = ''
  const aa = moment(firstEndTime).add(1, 'days').format('YYYY-MM-DD')
  const typeMap = {
    month: 'months-1',
    monthN: 'months-1',
    thirty: 'days-30',
    week: 'days-7',
    threeMonth: 'months-3',
    halfYear: 'months-6',
    year: 'years-1',
  }
  multiple = typeMap[paymentType].split('-')[1] || ''
  dateType = typeMap[paymentType].split('-')[0] || ''
  while (i < totalCycle - 1) {
    if (paymentType === 'monthN') {
      currentStartTime = moment(aa).add(i, dateType).format('YYYY-MM-DD 00:00:00')
      currentEndTime = moment(currentStartTime).endOf('month').format('YYYY-MM-DD 00:00:00')
    } else {
      // 每个周期的 - 开始时间都是上个周期的结束时间加一天，
      if (i === 0) {
        currentStartTime = moment(firstEndTime).add(1, 'days').format('YYYY-MM-DD 00:00:00')
      } else {
        currentStartTime = moment(nArr[i - 1].endCycleDate).add(1, 'days').format('YYYY-MM-DD 00:00:00')
      }
      // 每个周期的 - 结束时间为合同开始时间加循环的几个周期减一天
      currentEndTime = moment(firstStartTime).add((i + 2) * multiple, dateType).subtract(1, 'day').format('YYYY-MM-DD 00:00:00')
    }
    const eachCycle = {
      startCycleDate: currentStartTime,
      endCycleDate: currentEndTime,
      planAmount: arrears,
      num: i + 2,
    }
    const params = {
      type: paymentType,
      st: currentStartTime,
      ent: currentEndTime,
      payDay,
      delayPayFlag,
    }
    const dueDate = dueDateFun(params)
    eachCycle.dueDate = dueDate
    nArr.push(eachCycle)
    i++
  }
  return nArr
}

/**
 * 应缴日期计算
 * params = {
 *    type 付款方式
 *    st 开始时间
 *    ent 结束时间
 *    payDay 付款日
 *    delayPayFlag 是否后置缴款
 * }
 */
function dueDateFun(params = {}) {
  let payDate = ''
  let ind = ''
  const { type, delayPayFlag } = params
  let { st, ent, payDay } = params
  if (!type) {
    // 应缴日期计算：type 参数为空！
    return payDate
  } else if (!st) {
    // 应缴日期计算：st 参数为空！
    return payDate
  } else if (!ent) {
    // 应缴日期计算：ent 参数为空！
    return payDate
  } else if (!payDay && !delayPayFlag) {
    // 应缴日期计算：payDay 和 delayPayFlag 参数保证一个有值
    return payDate
  }
  st = moment(st).format('YYYY-MM-DD')
  ent = moment(ent).format('YYYY-MM-DD')

  // 是否后置缴款
  if (Number(delayPayFlag)) {
    payDate = moment(ent).add(1, 'days').format('YYYY-MM-DD')
    return payDate
  }
  // 缴费周期如果为【周】的话，计算应缴日期
  if (type === 'week') {
    let de = ''
    let i = 0
    if (Number(payDay) === 7) { // 页面选取的周日出入的数字数7，对应【moment().days()】为 0
      payDay = 0
    }
    const allDays = [st]
    while (i < 6) {
      de = moment(st).add(i + 1, 'days').format('YYYY-MM-DD')
      if (moment(de).isBefore(ent) || moment(de).isSame(ent)) {
        allDays.push(de)
      }
      i++
    }
    ind = allDays.findIndex((ii) => Number(moment(ii).days()) === Number(payDay))
    if (ind === -1) {
      payDate = allDays[0]
    } else {
      payDate = allDays[ind]
    }
    return payDate
  }
  // 缴费周期为【满月】或【自然月】或【30天】或【三个月】或【半年】或【一年】
  const ad = moment(ent).diff(moment(st), 'days')
  // 周期为一天
  if (ad === 0) { // 周期开始结束时间天数差为0，也就是周期为一天
    payDate = moment(st).format('YYYY-MM-DD 00:00:00')
    // 周期大于一天
  } else if (Number(moment(st).format('DD')) === Number(payDay)) {
    // 周期开始结束时间天数差大于0，周期最少为两天
    payDate = moment(st).format('YYYY-MM-DD 00:00:00')
  } else if (Number(moment(ent).format('DD')) === Number(payDay)) {
    payDate = moment(ent).format('YYYY-MM-DD 00:00:00')
  } else {
    let ssd = ''
    let i = 0
    while (i < Number(ad)) {
      ssd = moment(st).add(i + 1, 'days').format('DD')
      if (Number(ssd) === Number(payDay)) {
        payDate = moment(st).add(i + 1, 'days').format('YYYY-MM-DD 00:00:00')
        break
      }
      i++
    }
    payDate = payDate || moment(st).format('YYYY-MM-DD 00:00:00')
  }
  return payDate
}
